import BigNumber from 'bignumber.js';
import { NATIVE_TOKEN_ADDRESS, ZERO_ADDRESS } from 'modules/common/const';
import { TChainId } from '../chainIDs';
import { getReadProvider } from '../web3Provider';
import { IERC20 } from './abi';

/**
 * Requests token balance.
 *
 * @param chainId - chain id.
 * @param userAddress - user address.
 * @param tokenAddress - token address.
 *
 * @returns token balance in minimal units.
 */
export async function getBalanceByTokenAddr(
  chainId: TChainId,
  userAddress: string,
  tokenAddress: string,
): Promise<BigNumber> {
  const readProvider = await getReadProvider(chainId);
  const isNativeToken =
    tokenAddress === ZERO_ADDRESS || tokenAddress === NATIVE_TOKEN_ADDRESS;

  if (isNativeToken) {
    const balance = await readProvider.getWeb3().eth.getBalance(userAddress);
    return formatBalance(balance);
  } else {
    const tokenContract = readProvider.createContract(IERC20, tokenAddress);
    const balance: bigint = await tokenContract.methods
      .balanceOf(userAddress)
      .call();

    return formatBalance(balance);
  }
}

function formatBalance(balance: bigint): BigNumber {
  return new BigNumber(balance.toString(10));
}
